import React, { useEffect, useState } from "react";
import { Button, Form, Flex, Input, Row, Col, InputNumber } from "antd";
import { useForm } from "antd/es/form/Form";
import { useAppDispatch } from "../redux/hooks";
import axiosClient from "../api/axiosClient";
import Select from "../components/Select";
import { atcRequestVoucher } from "../redux/apiActions/requestsAction";
import useUser from "../hooks/useUser";

type Props = {
  popup: any;
};

const ATCVoucherForm: React.FC<Props> = ({ popup }: Props) => {
  const [form] = useForm();
  const dispatch = useAppDispatch();
  const { user } = useUser();
  const onFinish = async (values: any) => {
    if (user) {
      await dispatch(atcRequestVoucher({ atc_id: user.atc.id, data: values }));
      popup.close();
    }
  };

  const [exams, setExams] = useState<any>([]);

  useEffect(() => {
    axiosClient
      .get("/exams/atc")
      .then((res) => setExams(res.data))
      .catch((err) => {});
  }, []);

  return (
    <>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Row justify="center" style={{ marginTop: "30px" }}>
          <Col span={12}>
            <Select
              options={exams}
              placeholder={"Select Exam"}
              formItemProps={{
                name: "exam_id",
                label: "Exam",
              }}
            />

            <Form.Item
              label="No. of Vouchers"
              name="number_of_vouchers"
              rules={[
                { required: true, message: "No. of Vouchers is required" },
              ]}
            >
              <InputNumber className="full-width" />
            </Form.Item>

            <Form.Item
              label="Payment ID"
              name="payment_id"
              rules={[{ required: true, message: "Payment ID is required" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Invoice No"
              name="invoice_number"
              rules={[{ required: true, message: "Invoice No is required" }]}
            >
              <Input />
            </Form.Item>

            <Flex justify={"center"}>
              <Form.Item>
                <Button htmlType="submit">Submit</Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ATCVoucherForm;
